export const CATEGORY_FIELD = 'search_str';
